import axios from 'axios';
import authHeader from './auth-header';

const API_URL_DEFAULT = process.env.REACT_APP_API;

const getUsers = async (query) => {
	return axios.get(`${API_URL_DEFAULT}user/get-users`, {
		headers: await authHeader(),
		params: query,
	});
};

const getUserBy = async (query) => {
	return axios.get(`${API_URL_DEFAULT}user/by-dept-div-pos`, {
		headers: await authHeader(),
		params: query,
	});
};

const getAllDepartments = async () => {
	return axios.get(`${API_URL_DEFAULT}user/all-department`, {
		headers: await authHeader(),
	});
};

const getPosition = async (query) => {
	return axios.get(`${API_URL_DEFAULT}user/get-position`, {
		headers: await authHeader(),
		params: query,
	});
};

export default { getUsers, getUserBy, getAllDepartments, getPosition };
